import React from "react";
import Head from "next/head";
import gql from "graphql-tag";
import { Header } from "../../RefactorSearchPage/Header/web";
import "../../RefactorSearchPage/styles.less";
import { Footer } from "shared-components/ViewFragments/Footer/web";
import { PicHomeFooter } from "shared-components/ViewFragments/Footer/PicHomeFooter/web";
import { withApollo } from "../../lib/apollo3";
import { withAuth } from "../../lib/auth";
import { withContext } from "../../lib/context";
import { withGlobalComponents } from "../../shared-components/ViewFragments/GlobalComponents/web";
import { withTranslation } from "../../shared-components/i18n";

const LandingPage = ({ queryResult }) => {

    const { data, loading, error } = queryResult;

    return (
        <>
            <Header showSearchBar isSticky={false} />
            <Head>
                <meta name="robots" content="index,follow" />
                <title>Búsquedas populares de finca raíz Colombia</title>
            </Head>
            <h1>Búsquedas más populares de inmuebles en Colombia</h1>
            <div className="finca-link-box" style={{ display: "grid", gridTemplateColumns: "auto auto", width: "90%", margin: "0 auto" }}>
                {!loading && !error && data.SeoLandingsGeneratorList.data.map((e, k) => {
                    const title = JSON.parse(e.seo).title
                    return (<a key={k} href={`/inmuebles-colombia/${e.slug}`} target="_blank">{title}</a>)
                })}
            </div>
            <Footer />
            <PicHomeFooter />
        </>
    );
};

LandingPage.getInitialProps = async function ({ req, query, res, asPath, apolloClient, ...rest }) {

    const RESULTS_PER_PAGE = 900;
    const QUERY_SEARCH_RESULTS_CARDS = gql`
		query landingSeo($first: Int!, $page: Int) {
			SeoLandingsGeneratorList(first: $first, page: $page) {
                data {
                  id
                  seo
                  slug
                }
              }
		}
	`;
    const queryResult = await apolloClient.query({
        query: QUERY_SEARCH_RESULTS_CARDS,
        variables: {
            first: RESULTS_PER_PAGE,
            page: 1
        },
    });


    return {
        queryResult: queryResult
    };
};


export default withApollo(
    withContext(withTranslation(withAuth(withGlobalComponents(LandingPage))), {
        withDummyContext: false,
        withFiltersContext: false,
        withConfigContext: true,
        withThemeContext: true,
    })
);